/* eslint-disable */
// This file is generated by npm run build:icons
// Do not edit manually

import { Acrobat } from "../colorIcons/Acrobat";
import { FileCustom } from "../colorIcons/FileCustom";
import { FilePdf } from "../colorIcons/FilePdf";
import { FileSheet } from "../colorIcons/FileSheet";
import { Gmail } from "../colorIcons/Gmail";
import { Google } from "../colorIcons/Google";
import { Instagram } from "../colorIcons/Instagram";
import { InstagramDark } from "../colorIcons/InstagramDark";
import { LinkedIn } from "../colorIcons/LinkedIn";
import { LinkedInDark } from "../colorIcons/LinkedInDark";
import { Pinterest } from "../colorIcons/Pinterest";
import { PinterestDark } from "../colorIcons/PinterestDark";
import { PlatformAnalytics } from "../colorIcons/PlatformAnalytics";
import { PlatformContent } from "../colorIcons/PlatformContent";
import { Sheets } from "../colorIcons/Sheets";
import { Slack } from "../colorIcons/Slack";
import { Snap } from "../colorIcons/Snap";
import { TikTok } from "../colorIcons/TikTok";
import { TikTokDark } from "../colorIcons/TikTokDark";
import { Twitch } from "../colorIcons/Twitch";
import { TwitchDark } from "../colorIcons/TwitchDark";
import { YouTube } from "../colorIcons/YouTube";

// Create a mapping of color icon names to components
export const colorIconComponents = {
  Acrobat,
  FileCustom,
  FilePdf,
  FileSheet,
  Gmail,
  Google,
  Instagram,
  InstagramDark,
  LinkedIn,
  LinkedInDark,
  Pinterest,
  PinterestDark,
  PlatformAnalytics,
  PlatformContent,
  Sheets,
  Slack,
  Snap,
  TikTok,
  TikTokDark,
  Twitch,
  TwitchDark,
  YouTube,
} as const;
